module.exports = __webpack_public_path__ + "static/media/cargo-aircraft-loaded-with-containers-and-pallets-from-left-side.b2c0222d.jpg";